import React from "react";

export default function Profile() {
  return (
    <div class="profile-bio">
      <p>
        Learning react to make me a better developer. Check out my website{" "}
        <strong>
          <a
            style={{ textDecoration: "none", color: "inherit" }}
            href="https://www.srikanthgowda.com"
          >
            www.srikanthgowda.com
          </a>
        </strong>
      </p>
    </div>
  );
}
